import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

const ImageItemHeight = '60px';

export const FileImgListUploaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const FileImgContainer = styled.div`
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
  height: ${ImageItemHeight};
  background-color: ${palette('gray_opacity_100')};
`;

export const InputFileWrapper = styled.div`
  max-width: 120px;
  height: 44px;
  background-color: ${palette('gray_opacity_50')};
  border: 1px solid ${palette('gray_opacity_400')};
  box-sizing: border-box;
  border-radius: 8px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const InputFile = styled.input`
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  cursor: pointer;
`;

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;

  > svg {
      margin-right: 4px;
  }

  > * {
    align-self: center;
  }
`;

export const GuideTextContainer = styled.ul`
  list-style-type: "*";
  padding: 10px;
  margin-bottom: 0;
`;

export const GuideText = styled.li`
  margin: 6px 0px;
  color: ${palette('gray_opacity_400')};
  font-size: 13px;
`;

interface FileImgListContainerProps {
  maxHeightByItem?: number;
}

export const FileImgListContainer = styled.div<FileImgListContainerProps>`
  width: 100%;
  height: 100%;
  max-height: ${({maxHeightByItem}) => maxHeightByItem ? `calc(${ImageItemHeight} * ${maxHeightByItem})` : `calc(${ImageItemHeight} * 5)`};
  overflow-y: scroll;
  // Firefox
  scrollbar-color: ${palette('gray_neautral_scrollbar')} ${palette('transparent')};
  scrollbar-width: thin;
  // Chrome/Edge/Safari
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${palette('gray_neautral_scrollbar')};
}
`;

interface GradientProps {
  visible?: boolean;
  direction?: 'DOWN_SIDE' | 'UP_SIDE';
}

export const Gradient = styled.div<GradientProps>`
  display: ${({visible}) => visible ? 'block' : 'none'};
  position: relative;
  width: 100%;
  height: calc(${ImageItemHeight});
  transform: rotate(-180deg);
  pointer-events: none;

  ${({direction = 'UP_SIDE'}) => {
    if (direction === 'DOWN_SIDE') {
      return css`
        top: calc(${ImageItemHeight});
        margin-top: calc(${ImageItemHeight} * -1);
        background: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
      `;
    }

    if (direction === 'UP_SIDE') {
      return css`
        top: calc(${ImageItemHeight} * -1);
        margin-bottom: calc(${ImageItemHeight} * -1);
        background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
      `;
    }
  }}
`;
